import { createContext, useContext } from 'react';

type EscalationContextType = {
    escalationType: string;
    setEscalationType: React.Dispatch<React.SetStateAction<string>>;
    contactsEscalation: string[];
    setContactsEscalation: React.Dispatch<React.SetStateAction<string[]>>;
};

export const EscalationContext = createContext({} as EscalationContextType);

export const useEscalationContext = () => {
    const context = useContext(EscalationContext);

    if (!context) throw new Error('useEscalationContext must be used within a EscalationProvider');

    return context;
};
